import { z } from 'zod';

export const BrokerFiltersSchema = z.object({
  searchQuery: z.string().optional(),
  declarant: z.string().optional(),
});
